import FleetHelper from 'features/Fleet/fleetHelper';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import { useState } from 'react';

DialogUploadExcelView.propTypes = {
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogUploadExcelView({ onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isDragging, setIsDragging] = useState(false);

    // MARK: ---- METHODS ----

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setSelectedFile(file);
    };

    const handleRemoveFile = () => {
        setSelectedFile(null);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setIsDragging(false);

        const file = e.dataTransfer.files?.[0];

        if (!file) return;

        const allowedExtensions = ['xls', 'xlsx', 'xlsm'];
        const extension = file.name.split('.').pop()?.toLowerCase();

        if (!allowedExtensions.includes(extension)) {
            ToastHelper.showError('Chỉ hỗ trợ file Excel (.xls, .xlsx, .xlsm)');
            return;
        }

        setSelectedFile(file);
    };

    const handleSubmit = async () => {
        if (!selectedFile) {
            ToastHelper.showError('Vui lòng tải lên file hợp lệ');
            return;
        }
        setLoading(true);
        const res = await FleetHelper.API.requestUploadExcelFile(selectedFile);
        if (_.isBoolean(res) && res) {
            ToastHelper.showSuccess('Tải lên dữ liệu excel thành công');
            if (onDone) {
                onDone();
            }
        } else if (_.isString(res)) {
            ToastHelper.showError(res);
        }
        setLoading(false);
    };

    return (
        <div>
            <div className='p-4'>
                <div style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                    Các dữ liệu trong tệp excel phải được chuẩn hóa theo mẫu sau:{' '}
                    <span
                        className='cursor-pointer'
                        style={{
                            ...UIHelper.buildFontStyle('600', '14px', AppColors.primary),
                            textDecoration: 'underline'
                        }}
                        onClick={() => {
                            const link = document.createElement('a');
                            link.href =
                                'https://docs.google.com/spreadsheets/d/1GUkrM9_BtREH0RGpIuSgpp_p7l9ND-eI/export?format=xlsx';
                            link.click();
                        }}
                    >
                        Tải tệp excel mẫu
                    </span>
                </div>

                <div className='mt-4'>
                    <div
                        className='mb-3'
                        style={UIHelper.buildFontStyle('700', '13px', AppColors.gray[800])}
                    >
                        Tải lên tệp excel đã được chuẩn hóa để nhập dữ liệu
                    </div>

                    <label className='w-100 cursor-pointer'>
                        <div
                            className='d-flex flex-column align-items-center justify-content-center rounded py-5'
                            style={{
                                border: `1px dashed ${AppColors.primary}`,
                                backgroundColor: isDragging
                                    ? '#30BD6F1A'
                                    : '#30BD6F0D',
                                minHeight: 200,
                                transition: 'all .2s ease'
                            }}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                        >
                            {loading ? (
                                <>
                                    <i
                                        className='fa-solid fa-spinner fa-spin mb-3'
                                        style={{
                                            fontSize: 32,
                                            color: AppColors.primary
                                        }}
                                    />

                                    <div style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                        Dữ liệu đang được tải lên
                                    </div>
                                </>
                            ) : (
                                <>
                                    <i
                                        className='fa-solid fa-file-arrow-up mb-3'
                                        style={{
                                            fontSize: 36,
                                            color: AppColors.primary
                                        }}
                                    />

                                    <div style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                        Kéo thả hoặc ấn để tải lên
                                    </div>

                                    <div className='mt-2'
                                        style={UIHelper.buildFontStyle('500', '12px', AppColors.gray[600])}
                                    >
                                        Định dạng: .xls, .xlsx, .xlsm
                                    </div>
                                </>
                            )}
                        </div>

                        <input
                            type='file'
                            accept='.xls,.xlsx,.xlsm'
                            hidden
                            onChange={handleFileChange}
                            onClick={(e) => {
                                e.target.value = null;
                            }}
                        />
                    </label>

                    {selectedFile && (
                        <div
                            className='d-flex align-items-center justify-content-between mt-3 px-3 py-3 rounded'
                            style={{
                                backgroundColor: '#F4F3FF'
                            }}
                        >
                            <div className='d-flex align-items-center'>
                                <div
                                    className='d-flex align-items-center justify-content-center rounded'
                                    style={{
                                        minWidth: 30,
                                        minHeight: 30,
                                        backgroundColor: '#FFFFFF'
                                    }}
                                >
                                    <i
                                        className='fa-solid fa-file-excel'
                                        style={{
                                            fontSize: 16,
                                            color: '#1D9F4A'
                                        }}
                                    />
                                </div>

                                <div
                                    className='ml-3'
                                    style={{
                                        ...UIHelper.buildFontStyle('700', '13px', AppColors.gray[800]),
                                        wordBreak: 'break-word',
                                        overflowWrap: 'break-word',
                                        whiteSpace: 'normal',
                                        maxWidth: '100%'
                                    }}
                                >
                                    {selectedFile.name}
                                </div>
                            </div>

                            <i
                                className='fa-solid fa-xmark cursor-pointer mr-2'
                                style={{
                                    fontSize: 16,
                                    color: AppColors.gray[600]
                                }}
                                onClick={handleRemoveFile}
                            />
                        </div>
                    )}
                </div>
            </div>

            <div
                className='d-flex align-items-center justify-content-end gap-3 px-4 py-3'
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
                {UIHelper.buildGreenButton(
                    'Tải lên',
                    handleSubmit,
                    null,
                    true,
                )}
            </div>
        </div>
    );
}

export default DialogUploadExcelView;
